import React, { useState } from 'react';
import Tab from '.';

const TabGroup = ({ active, setActive, data }) => {
  return (
    <section className="border-light-grey-2 p-0 mb-2">
      <div className="flex items-center">
        {data &&
          data.map(item => (
            <div className={`${item.id !== 1 ? 'ml-5' : null}`} key={item.id}>
              <Tab
                active={active === item.name.toLocaleLowerCase()}
                onClick={() => setActive(item.name.toLocaleLowerCase())}
                label={item.name}
              />
            </div>
          ))}
      </div>
    </section>
  );
};

export default TabGroup;
